<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<!-- v-if="node.options && node.options.htmlTag === 'h1'" -->
		<general-tag
			:tag="tag"
			:class="getClass(node)"
			:style="getStyle(node)"
			class="pb-element pb-element-heading"
		>
			<!-- <div
				v-if="node.options && node.options.content"
				v-html="node.options.content">
			</div> -->
			<div
				v-if="node.options && node.options.content">
				<NodeEditor
					:key="node.key"
					v-model="node.options.content"
					@focus="onNodeClick(node)"
				/>
			</div>
		</general-tag>

	</div>
</template>

<script>
import { mapActions } from 'vuex';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	removeHtmlTags,
	getNodeStyle,
// eslint-disable-next-line
} from '@/lib/helper';


export default {
	name: 'NodeHeading',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		// eslint-disable-next-line
		NodeEditor,
	},
	computed: {
		tag() {
			return this.node?.options?.htmlTag ?? 'h2';
		},
	},
	watch: {},
	// mounted() {
	// 	window.addEventListener(`historyEvent-${this.node.key}`, this.historyEvent);
	// },
	// destroyed() {
	// 	window.removeEventListener(`historyEvent-${this.node.key}`, this.historyEvent);
	// },
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),
		getClass(node) {
			let pClass = node.class || '';
			if (node.options && node.options.align) {
				pClass += ` text-${node.options.align}`;
			}

			return pClass;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
				'padding',
				'border',
				'bg-color',
				'bg-img',
				'box-shadow',
				'text-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		removeHtmlTags(str) {
			return removeHtmlTags(str);
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
		onInput(value) {
			this.node.options.content = value;
		},
		historyEvent(event) {
			const detail = event.detail;
			if (this.node.key === detail.nodeKey) {
				this.node.options[detail.key] = detail.value;
			}
		},
	},
};
</script>

<style scoped></style>
